export default __webpack_public_path__ + "static/PuzzlesForEveryone-ab12707535eda443277f8ae76f07c600.webp";